import styled from '@emotion/styled';
import React from 'react';
import { connect } from 'react-redux';

import Complaint from '../../shared/Complaint/index.jsx';
import TextInput from '../../shared/TextInput/index.jsx';
import { BackArrow } from '../../shared/svgIcons.jsx';
import { MAX_TOTAL_NAME_LENGTH } from '../constants';
import { incrementStep, decrementStep, setFormData } from '../redux/actions';

const StepWrapper = styled.div`
  max-width: 23.125rem;
  width: 100%;
`;

const Header = styled.h3`
  font-family: 'OCRoboto';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  padding-top: 1rem;
  text-transform: none;
`;

const NextButton = styled.button`
  background-color: #d40f7d;
  border: none;
  color: #ffffff;
  cursor: pointer;
  font-size: 18px;
  padding: 0.5rem;
  width: 100%;
  margin-top: 1.5rem;

  :disabled {
    background-color: #d8d8d8;
    cursor: default;
  }
`;

const BackWrapper = styled.div`
  align-items: center;
  cursor: pointer;
  color: #333333;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 2rem;
  width: 100%;

  h3 {
    font-weight: 700;
    font-size: 16px;
    color: #000;
    text-transform: uppercase;
    font-family: 'OCRoboto';
  }
`;

const BackText = styled.p`
  margin-top: 0.5rem;
  padding-bottom: 1.5rem;
  text-align: center;
  font-size: 12px;
`;

const SplitInputContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 1rem;

  > div {
    width: 48%;
  }
`;

const InputWrapper = styled.div`
  width: 100%;
  padding: 0.5em 0;
`;

const mapStateToProps = state => ({
  formData: state.formData,
});

const emailRegEx = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

const NameLimitComplaint = ({ formData }) => {
  const totalNameLength = formData.propertyOwnerLName?.length + formData.propertyOwnerFName?.length;

  return (
    <Complaint
      text={`Combined limit for first name, last name reached (${MAX_TOTAL_NAME_LENGTH})`}
      show={totalNameLength >= MAX_TOTAL_NAME_LENGTH}
    />
  );
};

const HomeownerContent = ({ formData }) => (
  <StepWrapper>
    <Header>What’s your name?</Header>
    <SplitInputContainer>
      <TextInput
        fieldKey="propertyOwnerFName"
        htmlAttributes={{
          placeholder: 'First Name',
          maxLength: MAX_TOTAL_NAME_LENGTH - formData.propertyOwnerLName?.length,
        }}
      />
      <TextInput
        fieldKey="propertyOwnerLName"
        htmlAttributes={{
          placeholder: 'Last Name',
          maxLength: MAX_TOTAL_NAME_LENGTH - formData.propertyOwnerFName?.length,
        }}
      />
    </SplitInputContainer>
    <NameLimitComplaint formData={formData} />
  </StepWrapper>
);

const ContractorContent = ({ formData }) => (
  <StepWrapper>
    <Header>What is the Homeowner’s Name & Contact information?</Header>
    <SplitInputContainer>
      <TextInput
        fieldKey="propertyOwnerFName"
        htmlAttributes={{
          placeholder: 'First Name',
          maxLength: MAX_TOTAL_NAME_LENGTH - formData.homeownerLastName?.length,
        }}
      />
      <TextInput
        fieldKey="propertyOwnerLName"
        value={formData.homeownerLastName || ''}
        htmlAttributes={{
          placeholder: 'Last Name',
          maxLength: MAX_TOTAL_NAME_LENGTH - formData.homeownerFirstName?.length,
        }}
      />
      <NameLimitComplaint formData={formData} />
    </SplitInputContainer>
    <InputWrapper>
      <TextInput
        fieldKey="homeownerEmail"
        value={formData.homeownerEmail || ''}
        htmlAttributes={{
          placeholder: 'Email Address',
        }}
      />
      <Complaint
        text="Please enter a valid email address."
        show={formData.homeownerEmail ? emailRegEx.test(formData.homeownerEmail) === false : false}
      />
    </InputWrapper>
    <InputWrapper>
      <TextInput
        fieldKey="homeownerPhone"
        value={formData.homeownerPhone || ''}
        htmlAttributes={{
          placeholder: 'Phone Number',
          pattern: '[0-9 -]*',
          isphoneinput: 'true',
          maxLength: 12,
        }}
      />
    </InputWrapper>
  </StepWrapper>
);

const Step4 = ({ incrementStep, decrementStep, formData }) => {
  const contractorValidated =
    formData.propertyOwnerFName &&
    formData.propertyOwnerLName &&
    formData.homeownerEmail &&
    emailRegEx.test(formData.homeownerEmail) === true &&
    formData.homeownerPhone &&
    formData.homeownerPhone.length === 12;
  const homeownerValidated = formData.propertyOwnerFName && formData.propertyOwnerLName;
  const validated = formData.registrantType === 'homeowner' ? homeownerValidated : contractorValidated;

  return (
    <StepWrapper>
      <BackWrapper
        data-track="form-back"
        data-track-form-name="Warranty Registration"
        data-track-form-step={
          formData.registrantType === 'homeowner'
            ? "step 4 - what's your name"
            : "step 4 - what is the homeowner's name"
        }
        onClick={decrementStep}
      >
        <BackArrow width="21" height="12" />
        <h3>Back</h3>
        <BackText>For this property, are you the...</BackText>
      </BackWrapper>
      {formData.registrantType === 'homeowner' ? (
        <HomeownerContent formData={formData} />
      ) : (
        <ContractorContent formData={formData} />
      )}
      <NextButton
        data-track="form-advance"
        data-track-form-name="Warranty Registration"
        data-track-form-step={
          formData.registrantType === 'homeowner'
            ? "step 4 - what's your name"
            : "step 4 - what is the homeowner's name"
        }
        onClick={incrementStep}
        disabled={!validated}
      >
        Next
      </NextButton>
    </StepWrapper>
  );
};

const mapDispatchToProps = dispatch => ({
  incrementStep: () => dispatch(incrementStep()),
  decrementStep: () => dispatch(decrementStep()),
  setFormData: hash => dispatch(setFormData(hash)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Step4);
